import React from 'react';
import { LabelContainer } from './Pimple.styles';
import Popover from '../Popover/Popover';


type PimpleProps = {
  skin?: "default" | "brand";
  label: string;
  popoverContent: string | React.ReactNode;
};

const Pimple: React.FC<PimpleProps> = ({ label, popoverContent, skin: skin = 'default' }) => {

  const targetContent = (
    <LabelContainer className={`skin_${skin}`}>
      {label}
    </LabelContainer>
  );

  return <Popover
    targetContent={targetContent}
    dropdownContent={popoverContent}
  />
}

export default Pimple;
